import {getStatusCell, renderFormField} from '@common'
import {TranslationKey} from '@enums'
import {Button, CircularProgress, Grid, Stack} from '@mui/material'

import React from 'react'

import {UIKit} from '@components'

import {useContractViewModel} from './contract-view-model'
import {ButtonsWrapper, CancelBtn, Label, pdfViewStyle} from './style'

/**
 * Contract View page
 */
export function ContractViewPage() {
  const {
    pdfUrl,
    contractOverviewFormFields,
    signingFormFields,
    isSignatureOptionsModalVisible,
    isPdfModalOpen,
    contractDetailFormFields,
    isPdfTransferModalOpen,
    pdfTransferUrl,
    filteredBtns,
    contractStatus,
    loadingPdf,
    setIsPdfTransferModalOpen,
    onDownloadTransferBtnClick,
    setIsPdfModalOpen,
    setIsSignatureOptionsModalVisible,
    onSendForSigningBtnClick,
    onDownloadBtnClick,
    t,
  } = useContractViewModel()

  return (
    <>
      <UIKit.BackgroundCard title={t(TranslationKey['Contract overview'])}>
        <Grid container spacing={2}>
          <Grid item sm={3}>
            <Stack style={{alignItems: 'flex-start', gap: '0.5rem'}}>
              <Label>{t(TranslationKey.Status)}</Label>
              <Stack style={{width: 150}}>{contractStatus && getStatusCell(t, contractStatus)}</Stack>
            </Stack>
          </Grid>
          {contractOverviewFormFields.map((item, index) => (
            <Grid key={`contract-overview-form-field-${index}`} item sm={3}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>
      <UIKit.BackgroundCard>
        <Grid container spacing={2}>
          {contractDetailFormFields.map((item, index) => (
            <Grid key={`contract-details-form-field-${index}`} item sm={3}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>
      <UIKit.BackgroundCard>
        <ButtonsWrapper>
          {Object.values(filteredBtns).map(({label, onClick, variant}, index) => {
            const BtnComponent = variant === 'cancel' ? CancelBtn : Button

            return (
              <BtnComponent
                key={`action-btn-${index}`}
                style={{flex: 1, maxWidth: 200}}
                onClick={onClick}
                variant={variant === 'cancel' ? 'contained' : variant}
              >
                {label}
              </BtnComponent>
            )
          })}
        </ButtonsWrapper>
      </UIKit.BackgroundCard>
      <UIKit.Modal
        open={isSignatureOptionsModalVisible}
        title={t(TranslationKey['Send for signing'])}
        cancelButtonProps={{
          buttonText: t(TranslationKey.Cancel),
          onClick: () => setIsSignatureOptionsModalVisible(false),
        }}
        confirmButtonProps={{
          buttonText: t(TranslationKey['Send for signing']),
          onClick: onSendForSigningBtnClick,
        }}
        content={
          <Stack gap={2}>
            {signingFormFields.map((item, index) => (
              <Stack key={`signing-form-field-${index}`}>{renderFormField(item)}</Stack>
            ))}
          </Stack>
        }
      />

      <UIKit.Modal
        open={isPdfModalOpen}
        title={t(TranslationKey['PDF overview'])}
        cancelButtonProps={{
          buttonText: t(TranslationKey.Close),
          onClick: () => setIsPdfModalOpen(false),
        }}
        confirmButtonProps={{
          buttonText: t(TranslationKey['Download PDF']),
          disabled: loadingPdf,
          onClick: onDownloadBtnClick,
        }}
        styles={{
          paper: {maxWidth: '100%'},
          content: {
            padding: 0,
            margin: 0,
            overflow: 'hidden',
          },
        }}
        content={
          <Stack gap={2} style={{width: '715px', height: '600px', padding: '15px'}}>
            {loadingPdf ? (
              <Stack style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                <CircularProgress />
              </Stack>
            ) : (
              <iframe
                src={`${pdfUrl}#toolbar=0&navpanes=0&view=FitW`}
                title="PDF Viewer"
                width="100%"
                height="100%"
                style={pdfViewStyle}
              />
            )}
          </Stack>
        }
      />

      <UIKit.Modal
        open={isPdfTransferModalOpen}
        title={t(TranslationKey['PDF overview'])}
        cancelButtonProps={{
          buttonText: t(TranslationKey.Close),
          onClick: () => setIsPdfTransferModalOpen(false),
        }}
        confirmButtonProps={{
          buttonText: t(TranslationKey['Download PDF']),
          disabled: loadingPdf,
          onClick: onDownloadTransferBtnClick,
        }}
        styles={{
          paper: {maxWidth: '100%'},
          content: {
            padding: 0,
            margin: 0,
            overflow: 'hidden',
          },
        }}
        content={
          <Stack gap={2} style={{width: '715px', height: '600px', padding: '15px'}}>
            {loadingPdf ? (
              <Stack style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                <CircularProgress />
              </Stack>
            ) : (
              <iframe
                src={`${pdfTransferUrl}#toolbar=0&navpanes=0&view=FitW`}
                title="PDF Viewer"
                width="100%"
                height="100%"
                style={pdfViewStyle}
              />
            )}
          </Stack>
        }
      />
    </>
  )
}
